<template>
  <div class="form-group" v-if="field.web">
    <div v-if="field.type == 'number'">
      <label>{{ field.label == undefined ? field.name : field.label }}</label>
      <b-form-input
        :placeholder="field.name"
        :value="123"
        v-model="value"
        :class="{ 'is-invalid': hasError }"
      ></b-form-input>
      <div v-if="hasError" class="invalid-feedback">
        <span>{{ errorMessage }}</span>
      </div>
    </div>
    <div
      v-if="
        (field.type == 'dropDown' && field.name == 'Employee') ||
        (field.type == 'dropdown' && field.name == 'User')
      "
    >
      <div class="form-group">
        <label>{{ field.label == undefined ? field.name : field.label }}</label>
        <v-select
          :options="field.collection"
          label="name"
          v-model="value"
          :class="{ 'is-invalid ddl-is-invalid': hasError }"
          v-on:input="ddlChange(field.name, value)"
          transition=""
        ></v-select>
        <div v-if="hasError" class="invalid-feedback">
          <span>{{ errorMessage }}</span>
        </div>
      </div>
    </div>
    <div
      v-if="
        field.type == 'dropdown' &&
        field.name != 'Employee' &&
        field.type == 'dropdown' &&
        field.name != 'User'
      "
    >
      <div class="form-group">
        <label>{{ field.label == undefined ? field.name : field.label }}</label>
        <v-select
          :options="field.collection"
          :label="field.name"
          v-model="value"
          :class="{ 'is-invalid ddl-is-invalid': hasError }"
          v-on:input="ddlChange(field.name, value)"
          transition=""
        ></v-select>
        <div v-if="hasError" class="invalid-feedback">
          <span>{{ errorMessage }}</span>
        </div>
      </div>
    </div>
    <div v-if="field.type == 'dateTime'">
      <label>{{ field.label == undefined ? field.name : field.label }}</label>
      <date-picker
        v-model="value"
        :first-day-of-week="1"
        lang="en"
        :placeholder="field.name"
        :class="{ 'is-invalid': hasError }"
        :input-class="{
          'form-control mx-input date-is-invalid': hasError,
          'form-control mx-input': !hasError,
        }"
        :disabled-date="disabledDates"
      ></date-picker>
      <div v-if="hasError" class="invalid-feedback">
        <span>{{ errorMessage }}</span>
      </div>
    </div>
    <div v-if="field.type == 'textarea'">
      <label>{{ field.label == undefined ? field.name : field.label }}</label>
      <textarea
        class="form-control"
        rows="3"
        :placeholder="field.label == undefined ? field.name : field.label"
        v-model="value"
        :class="{ 'is-invalid': hasError }"
      ></textarea>
      <div v-if="hasError" class="invalid-feedback">
        <span>{{ errorMessage }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getEmployeesRate, getProductsRate } from '../helper/dbHelpers.js';
import DatePicker from 'vue2-datepicker';

export default {
  name: 'dynamicControls',
  components: {
    DatePicker,
  },
  props: {
    field: null,
    futureDatesEnabled: Boolean
  },
  data() {
    return {
      value: null,
      hasError: false,
      errorMessage: null,
      collection: [],
    };
  },
  methods: {
    disabledDates(date) {
      // prevent future dates unless manually enabled
      if (this.futureDatesEnabled) {
        return false;
      }
      const today = new Date();
      return date > today;
    },
    ddlChange(fieldName, value) {
      //if this is the employee field, then we need to get the employee's rate.
      if (fieldName == 'Employee') {
        getEmployeesRate(value.name)
          .then((response) => {
            response.forEach((doc) => {
              this.$emit(
                'updateRate',
                doc.data().rate,
                doc.data().overtimeRate,
                doc.data().travelTimeRate,
                value,
                false //value given for ratesFetched prop, updateRate is used in jobDetails component locally aswell this is to differentiate
              );
              this.$emit('updateAuth', doc.data().auth);
            });
          })
          .catch((err) => {
            console.log(`Error getting employee's rate: ${err}`);
          });
      }
      if (fieldName == 'Products') {
        getProductsRate(value)
          .then((response) => {
            response.forEach((doc) => {
              this.$emit(
                'updateProductRate',
                doc.data().defaultRate,
                doc.id,
                doc.data().price
              );
            });
          })
          .catch((err) => {
            console.log(`Error getting product's rate: ${err}`);
          });
      }
    },
  },
};
</script>
